import { Injectable }         from '@angular/core';
import { CanActivate, Router} from '@angular/router';

import { OAuthService }       from 'angular-oauth2-oidc';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private authService: OAuthService, private router: Router) {
  }

  canActivate(): boolean {
    if (this.authService.hasValidAccessToken()) {
      return true;
    } else {
      return false;
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/guards/auth.guard.ts